import React, { useCallback, useEffect, useState } from 'react';

import { TooltipStateful } from '@yandex-360/orb-components/dist/components/Tooltip';
import { useSelector } from 'react-redux';

import { Button, SvgImage } from '../../../../../../shared/components';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { selectIsReportAProblemAvailable } from '../../selectors';
import { ReportAProblemForm } from '../report-a-problem-form';
import styles from './styles.css';

export function ReportAProblemButton() {
    const [isFromShown, setIsFromShown] = useState(false);

    const isReportAProblemAvailable = useSelector(selectIsReportAProblemAvailable);

    const onClick = useCallback(() => {
        countMetrika('meeting_screen', 'problem_button', 'click');
        setIsFromShown(true);
    }, []);

    useEffect(() => {
        if (isReportAProblemAvailable) {
            countMetrika('meeting_screen', 'problem_button', 'show');
        }
    }, [isReportAProblemAvailable]);

    if (!isReportAProblemAvailable) {
        return null;
    }

    return (
        <>
            <div className={styles.button}>
                <TooltipStateful
                    content={i18n('feedback', 'report-a-problem-button')}
                    trigger="hover"
                    placement="right"
                    offset={5}
                >
                    <div>
                        <Button
                            onClick={onClick}
                            size="lg"
                            view="neutral"
                            icon={<SvgImage imageName="reportAProblem" />}
                        />
                    </div>
                </TooltipStateful>
            </div>
            {isFromShown && <ReportAProblemForm onClose={() => setIsFromShown(false)} />}
        </>
    );
}
